import { FiArrowRight, FiClock, FiShield } from "react-icons/fi";
import { isPersonStatusVerified } from "../../../Utils/accountKycStatus";

const BANNER_CONTENT = {
  onboarding: {
    icon: FiShield,
    title: "Conta Individualizada disponível",
    description:
      "Ative em poucos minutos: cadastro simples, verificação segura e mais autonomia nas suas operações.",
    cta: "Ativar agora",
    action: "open",
  },
  pending: {
    icon: FiClock,
    title: "Cadastro em análise",
    description:
      "Recebemos sua solicitação. Avisaremos assim que sua Conta Individualizada for aprovada.",
    cta: null,
    action: null,
  },
  ready: {
    icon: FiShield,
    title: "Conta Individualizada ativa",
    description:
      "Sua conta já está pronta para uso. Selecione a opção acima para começar a operar.",
    cta: null,
    action: null,
  },
};

export const IndividualAccountPromoBanner = ({
  canUseIndividualAccount,
  isPendingReview,
  needsOnboarding,
  isLoadingStatus,
  /** @deprecated Prefer personStatus — kept for Dashboard callers. */
  isKycPending,
  /** Person KYC status from /me (`verified` | `pending` | …). */
  personStatus,
  onOpenOnboarding,
}) => {
  // Exact condition: show only when person status !== `verified`.
  const showBanner =
    personStatus != null && String(personStatus).trim() !== ""
      ? !isPersonStatusVerified(personStatus)
      : Boolean(isKycPending);

  if (isLoadingStatus || !showBanner) return null;

  let content = null;

  if (needsOnboarding) {
    content = BANNER_CONTENT.onboarding;
  } else if (isPendingReview) {
    content = BANNER_CONTENT.pending;
  } else if (canUseIndividualAccount) {
    content = BANNER_CONTENT.ready;
  }

  if (!content) return null;

  const Icon = content.icon;

  const handleAction = () => {
    if (content.action === "open") {
      onOpenOnboarding?.();
    }
  };

  return (
    <div
      className={`individual-account-banner ${
        content.action ? "individual-account-banner--interactive" : ""
      }`}
      role={content.action ? "button" : undefined}
      tabIndex={content.action ? 0 : undefined}
      onClick={content.action ? handleAction : undefined}
      onKeyDown={
        content.action
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleAction();
              }
            }
          : undefined
      }
    >
      <div className="individual-account-banner__icon">
        <Icon className="h-5 w-5" />
      </div>

      <div className="individual-account-banner__body">
        <p className="individual-account-banner__title">{content.title}</p>
        <p className="individual-account-banner__description">{content.description}</p>
      </div>

      {content.cta ? (
        <span className="individual-account-banner__cta">
          {content.cta}
          <FiArrowRight className="h-4 w-4" />
        </span>
      ) : null}
    </div>
  );
};
